import type { Activity_category } from "@prisma/client";
import { useEffect, useState } from "react";
import { ACTIVITIES } from "src/const/activities";

export const useRecommendedText = ({
  category,
  meta,
}: {
  category: Activity_category;
  meta: { [key: string]: string | number };
}) => {
  const [text, setText] = useState<string>("");
  useEffect(() => {
    const foundActivity = ACTIVITIES.find((activity) => {
      return category === activity.activity;
    });

    if (foundActivity) {
      if (meta?.rank) {
        setText(`ランキング${meta?.rank}${foundActivity.wording}`);
      } else {
        setText(foundActivity.wording);
      }
    } else {
      setText("");
    }
  }, [category, meta?.rank]);

  return { text };
};
